(function () {
  if (window.__fastplusShopifyCartReady) return;
  window.__fastplusShopifyCartReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = { cart: null, shell: null, button: null, panel: null, loading: false };

  function endpoint(path) {
    return root.replace(/\/$/, '') + path;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  async function request(path, options) {
    var response = await fetch(endpoint(path), Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, options || {}));
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart request failed.');
    }
    return data;
  }

  function setBusy(isBusy) {
    state.loading = isBusy;
    if (state.panel) state.panel.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function setOpen(isOpen) {
    if (!state.shell || !state.button || !state.panel) return;
    state.shell.classList.toggle('is-open', isOpen);
    state.panel.classList.toggle('is-open', isOpen);
    state.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.classList.remove('fp-cart-lock');
  }

  function render(cart) {
    if (!state.panel || !cart) return;
    var count = Number(cart.item_count) || 0;
    var currency = cart.currency || 'USD';
    var badge = state.button.querySelector('#cart-badge') || document.getElementById('cart-badge');
    var meta = state.panel.querySelector('#cart-preview-meta');
    var total = state.panel.querySelector('#cart-preview-total');
    var list = state.panel.querySelector('#cart-preview-list');
    var clear = state.panel.querySelector('[data-cart-action="clear"]');
    var checkout = state.panel.querySelector('.fp-cart-actions .btn-primary');

    if (badge) badge.textContent = count > 99 ? '99+' : String(count);
    state.button.setAttribute('aria-label', 'Open cart, ' + count + ' item' + (count === 1 ? '' : 's') + ' in cart, subtotal ' + formatMoney(cart.total_price, currency));
    if (meta) meta.textContent = count + ' item' + (count === 1 ? '' : 's') + ' in your cart';
    if (total) total.textContent = formatMoney(cart.total_price, currency);
    if (clear) clear.disabled = count === 0;
    if (checkout) {
      checkout.href = endpoint('/checkout');
      checkout.textContent = 'Checkout';
    }
    if (!list) return;

    if (!count) {
      list.innerHTML = '<div class="fp-cart-empty">Your Shopify cart is empty.</div>';
      return;
    }

    list.innerHTML = cart.items.map(function (item) {
      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      var title = item.product_title || item.title || 'Product';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<small>' + escapeHtml(item.variant_title) + '</small>'
        : '';
      return '<div class="fp-cart-item" data-cart-item data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + item.quantity + '">' +
        (image ? '<a href="' + escapeHtml(item.url || '#') + '"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '"></a>' : '') +
        '<div class="fp-cart-item-body">' +
          '<a href="' + escapeHtml(item.url || '#') + '"><strong>' + escapeHtml(title) + '</strong></a>' +
          variant +
          '<div class="fp-cart-item-meta"><span>' + item.quantity + ' x ' + formatMoney(item.final_price, currency) + '</span><strong class="fp-cart-item-total">' + formatMoney(item.final_line_price, currency) + '</strong></div>' +
          '<div class="fp-cart-controls"><div class="fp-cart-qty-box" aria-label="Quantity controls">' +
            '<button type="button" class="qty-btn" data-cart-action="qty" data-delta="-1" aria-label="Decrease quantity">-</button>' +
            '<span class="fp-cart-qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="qty-btn" data-cart-action="qty" data-delta="1" aria-label="Increase quantity">+</button>' +
          '</div><button type="button" class="fp-cart-remove" data-cart-action="remove">Remove</button></div>' +
        '</div></div>';
    }).join('');
  }

  async function refresh(openAfter) {
    try {
      setBusy(true);
      state.cart = await request('/cart.js');
      render(state.cart);
      if (openAfter) setOpen(true);
      window.dispatchEvent(new CustomEvent('fastplus-shopify-cart-updated', { detail: state.cart }));
      return state.cart;
    } finally {
      setBusy(false);
    }
  }

  async function changeLine(key, quantity) {
    var cart = await request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    state.cart = cart;
    render(cart);
    return cart;
  }

  async function clearCart() {
    var cart = await request('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}'
    });
    state.cart = cart;
    render(cart);
    return cart;
  }

  async function addItems(items) {
    if (!items || !items.length) return refresh(true);
    await request('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    return refresh(true);
  }

  async function productJson(handle) {
    return request('/products/' + encodeURIComponent(handle) + '.js');
  }

  function variantForGrit(product, grit) {
    var target = String(grit || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var available = (product.variants || []).filter(function (variant) { return variant.available !== false; });
    if (target) {
      var matched = available.find(function (variant) {
        var pool = [variant.title].concat(variant.options || []).join(' ').toLowerCase().replace(/[^a-z0-9]/g, '');
        return pool.indexOf(target) !== -1;
      });
      if (matched) return matched;
    }
    return available[0] || (product.variants || [])[0];
  }

  async function itemForHandle(handle, quantity, grit) {
    var product = await productJson(handle);
    var variant = variantForGrit(product, grit);
    if (!variant) throw new Error('No available variant for ' + handle + '.');
    var item = { id: variant.id, quantity: Math.max(1, Number(quantity) || 1) };
    if (grit) item.properties = { 'Selected grit': grit };
    return item;
  }

  function feedback(message, isError) {
    var node = document.getElementById('cart-feedback');
    if (!node) return;
    node.textContent = message;
    node.style.color = isError ? '#b42318' : '';
  }

  async function submitProductForm(form) {
    var submit = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (!formData.get('id')) throw new Error('Please choose an available product option.');
    if (submit) submit.disabled = true;
    feedback('Adding to Shopify cart...', false);
    try {
      await request('/cart/add.js', { method: 'POST', body: formData });
      await refresh(true);
      feedback('Added to your Shopify cart.', false);
    } finally {
      if (submit) submit.disabled = false;
    }
  }

  async function addProjectSet(button) {
    var card = button.closest('[data-set-products]');
    if (!card) return;
    var selections = String(card.dataset.setProducts || '').split(',').map(function (entry) {
      var parts = entry.split('::');
      return { handle: parts[0], grit: parts[1] || '' };
    }).filter(function (entry) { return entry.handle; });
    button.disabled = true;
    button.textContent = 'Adding...';
    try {
      var items = await Promise.all(selections.map(function (entry) {
        return itemForHandle(entry.handle, 1, entry.grit);
      }));
      await addItems(items);
      button.textContent = 'Set Added';
      var note = card.querySelector('[data-set-feedback]');
      if (note) {
        note.textContent = selections.length + ' products added to your Shopify cart.';
        note.classList.add('is-visible');
      }
    } finally {
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = 'Add Set to Cart';
      }, 1800);
    }
  }

  function takeOverCartUi() {
    var oldButton = document.getElementById('cart-toggle');
    var oldPanel = document.getElementById('cart-preview');
    if (!oldButton || !oldPanel) return false;
    var button = oldButton.cloneNode(true);
    var panel = oldPanel.cloneNode(true);
    oldButton.replaceWith(button);
    oldPanel.replaceWith(panel);
    state.button = button;
    state.panel = panel;
    state.shell = button.closest('[data-fp-cart-shell]') || panel.closest('[data-fp-cart-shell]') || button.parentElement;

    button.addEventListener('click', function () {
      var open = !panel.classList.contains('is-open');
      setOpen(open);
      if (open) refresh(false).catch(showError);
    });

    panel.addEventListener('click', function (event) {
      var close = event.target.closest('[data-cart-close]');
      if (close) {
        setOpen(false);
        return;
      }
      var action = event.target.closest('[data-cart-action]');
      if (!action || state.loading) return;
      event.preventDefault();
      setBusy(true);
      var task;
      if (action.dataset.cartAction === 'clear') {
        task = clearCart();
      } else {
        var item = action.closest('[data-cart-item]');
        if (!item) return setBusy(false);
        var key = item.dataset.lineKey;
        var quantity = Number(item.dataset.quantity) || 0;
        task = changeLine(key, action.dataset.cartAction === 'remove' ? 0 : quantity + Number(action.dataset.delta || 0));
      }
      task.catch(showError).finally(function () { setBusy(false); });
    });

    var backdrops = state.shell ? state.shell.querySelectorAll('.fp-cart-backdrop') : [];
    Array.prototype.forEach.call(backdrops, function (backdrop) {
      backdrop.addEventListener('click', function () { setOpen(false); });
    });
    return true;
  }

  function showError(error) {
    console.error(error);
    feedback(error && error.message ? error.message : 'Unable to update the Shopify cart.', true);
  }

  function bindPurchases() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (form.id !== 'product-form' && !form.hasAttribute('data-fastplus-quick-add') && action.indexOf('/cart/add') === -1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      submitProductForm(form).catch(showError);
    }, true);

    document.addEventListener('click', function (event) {
      var setButton = event.target.closest('[data-shop-set]');
      if (!setButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addProjectSet(setButton).catch(function (error) {
        setButton.disabled = false;
        setButton.textContent = 'Add Set to Cart';
        showError(error);
      });
    }, true);
  }

  function init() {
    if (!takeOverCartUi()) return;
    bindPurchases();
    refresh(false).catch(showError);
    window.addEventListener('focus', function () { refresh(false).catch(function () {}); });
    window.addEventListener('pageshow', function () { refresh(false).catch(function () {}); });
    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(function () {
        if (takeOverCartUi()) refresh(false).catch(showError);
      }, 0);
    });
  }

  window.FastplusShopifyCart = {
    addItems: addItems,
    itemForHandle: itemForHandle,
    refresh: refresh
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
